// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

const ENCODED_FILENAME_PATTERN = /filename\*\s*=\s*[^']*'[^']*'([^;\s]+)/i;
const QUOTED_FILENAME_PATTERN = /filename\s*=\s*"((?:[^"\\]|\\.)*)"/i;
const BARE_FILENAME_PATTERN = /filename\s*=\s*([^";\s][^;\s]*)/i;
const QUOTED_PAIR_PATTERN = /\\(.)/g;

/**
 * Reads the file name a Content-Disposition header names, or null if it names none.
 */
export function getFilenameFromContentDisposition(
  header: string | null | undefined
): string | null {
  if (!header) {
    return null;
  }

  // A name outside ASCII arrives percent-encoded as UTF-8 in filename*, per RFC 5987.
  const encodedMatch = ENCODED_FILENAME_PATTERN.exec(header);
  if (encodedMatch) {
    return decodeURIComponent(encodedMatch[1]);
  }

  // A quoted name escapes its quotes and backslashes with a backslash.
  const quotedMatch = QUOTED_FILENAME_PATTERN.exec(header);
  if (quotedMatch) {
    return quotedMatch[1].replace(QUOTED_PAIR_PATTERN, '$1');
  }

  return BARE_FILENAME_PATTERN.exec(header)?.[1] ?? null;
}
